import React, { useEffect } from 'react';
import { Card, Space } from 'antd';
import { FileUpload } from './FileUpload';
import FileList from './FileList';
import { useFiles } from '@/contexts/FileContext';

interface TournamentFilesProps {
  tournamentId: number;
  canEdit?: boolean;
}

export const TournamentFiles: React.FC<TournamentFilesProps> = ({
  tournamentId,
  canEdit = false
}) => {
  const { loadFiles } = useFiles();

  useEffect(() => {
    if (loadFiles) {
      loadFiles(tournamentId);
    }
  }, [tournamentId, loadFiles]);

  return (
    <Card title="Файлы турнира">
      <Space direction="vertical" style={{ width: '100%' }}>
        {canEdit && <FileUpload tournamentId={tournamentId} />}
        <FileList tournamentId={tournamentId} canDelete={canEdit} />
      </Space>
    </Card>
  );
};

export default TournamentFiles;
